var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAiGrid = function SvgAiGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    id: "ai-grid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4413_372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FBFFA",
    fillRule: "evenodd",
    d: "M0.0848999 1.08973C0.0848999 0.546677 0.525131 0.106445 1.06818 0.106445H5.24714C5.7902 0.106445 6.23043 0.546677 6.23043 1.08973V5.26869C6.23043 5.81174 5.7902 6.25197 5.24714 6.25197H1.06818C0.525131 6.25197 0.0848999 5.81174 0.0848999 5.26869V1.08973ZM1.06819 7.74803C0.525132 7.74803 0.0848999 8.18826 0.0848999 8.73131V12.9103C0.0848999 13.4533 0.525132 13.8936 1.06819 13.8936H5.24714C5.7902 13.8936 6.23043 13.4533 6.23043 12.9103V8.73131C6.23043 8.18826 5.7902 7.74803 5.24714 7.74803H1.06819ZM8.70977 7.74803C8.16671 7.74803 7.72648 8.18826 7.72648 8.73131V12.9103C7.72648 13.4533 8.16671 13.8936 8.70977 13.8936H12.8887C13.4318 13.8936 13.872 13.4533 13.872 12.9103V8.73131C13.872 8.18826 13.4318 7.74803 12.8887 7.74803H8.70977Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2859C5",
    fillRule: "evenodd",
    d: "M11.4701 0.729109C11.2839 -0.0875073 10.1188 -0.0824145 9.93972 0.735798L9.93291 0.767015L9.91961 0.827571C9.72431 1.70212 9.02101 2.37322 8.13755 2.52692C7.2852 2.67521 7.28521 3.89879 8.13755 4.04708C9.02409 4.20131 9.72921 4.87657 9.92164 5.75561L9.93972 5.8382C10.1188 6.65641 11.2839 6.66151 11.4701 5.84489L11.4921 5.74864C11.6918 4.87275 12.398 4.20242 13.2831 4.04844C14.1369 3.89989 14.1369 2.67411 13.2831 2.52556C12.4027 2.37239 11.6993 1.70834 11.4953 0.839293C11.4896 0.815004 11.4843 0.791782 11.4786 0.766501L11.4701 0.729109Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4413_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAiGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ai-grid.3bc75c23.svg";
export { ForwardRef as ReactComponent };